import axios from 'axios'
import { useMutation, useQueryClient } from 'react-query'

export const useCreateLocation = () => {
  const queryClient = useQueryClient()

  return useMutation((body: any) => axios.put(`/locationtags`, body), {
    onSuccess: () => {
      queryClient.invalidateQueries(['locationtags'])
    }
  })
}
